import { render, staticRenderFns } from "./zzjl.vue?vue&type=template&id=3b95e1d6&scoped=true&"
import script from "./zzjl.vue?vue&type=script&lang=js&"
export * from "./zzjl.vue?vue&type=script&lang=js&"
import style0 from "./zzjl.vue?vue&type=style&index=0&id=3b95e1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95e1d6",
  null
  
)

export default component.exports